import { createRoute } from "@tanstack/react-router";
import { withPermission } from "../lib/with-permission";
import { useTranslation } from "react-i18next";
import { rootRoute } from "./__root";
import { PageHeader } from "../components/ui/PageHeader/PageHeader";
import { Card } from "../components/ui/Card/Card";
import { LoadingSpinner } from "../components/ui/LoadingSpinner/LoadingSpinner";
import { ErrorFallback } from "../components/ui/ErrorFallback/ErrorFallback";
import { BackButton } from "../components/ui/BackButton/BackButton";
import { formatDate } from "../lib/date";
import { useWarehouseDetail } from "../hooks/use-warehouses";
import styles from "./WarehouseDetail.module.css";

export const route = createRoute({
	getParentRoute: () => rootRoute,
	path: "/warehouses/$id",
	component: withPermission(WarehouseDetailPage, "warehouses", "read"),
});

function WarehouseDetailPage() {
	const { id } = route.useParams();
	const { t } = useTranslation();
	const warehouseQuery = useWarehouseDetail(id);

	if (warehouseQuery.isLoading) return <LoadingSpinner />;
	if (warehouseQuery.isError || !warehouseQuery.data)
		return <ErrorFallback onRetry={warehouseQuery.refetch} />;

	const wh = warehouseQuery.data;

	return (
		<div>
			<BackButton fallbackTo="/warehouses" />
			<PageHeader title={wh.name} />

			<div className={styles.grid}>
				<Card header={t("warehouseInfo")}>
					<div className={styles.infoGrid}>
						<Info label={t("code")} value={wh.code} />
						<Info label={t("name")} value={wh.name} />
						<Info label={t("location")} value={wh.location} />
						<Info label={t("street")} value={wh.street} />
						<Info label={t("city")} value={wh.city} />
						<Info label={t("country")} value={wh.country} />
						<Info label={t("sapWhsCode")} value={wh.sapWhsCode} />
						<Info
							label={t("lastSyncedAt")}
							value={wh.lastSyncedAt ? formatDate(wh.lastSyncedAt) : "-"}
						/>
					</div>
				</Card>
			</div>
		</div>
	);
}

function Info({ label, value }: { label: string; value: string | null }) {
	return (
		<div>
			<span className={styles.infoLabel}>{label}</span>
			<p className={styles.infoValue}>{value || "-"}</p>
		</div>
	);
}
